import(/* webpackMode: "eager" */ "/vercel/path0/app/fund/opportunities/page.tsx");
